export default __webpack_public_path__ + "static/media/line5.efba4936.svg";